export enum TerminalOperationType {
  ADD_TERMINAL_ID_TO_USER,
  CHANGE_TERMINAL_ID_TO_ADMIN_USER,
  CHANGE_TERMINAL_ID_TO_STAFF_USER,
  CHOOSE_AGAIN,
}